import { render, staticRenderFns } from "./subject-column.vue?vue&type=template&id=72f8ae52&scoped=true"
import script from "./subject-column.vue?vue&type=script&lang=js"
export * from "./subject-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f8ae52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72f8ae52')) {
      api.createRecord('72f8ae52', component.options)
    } else {
      api.reload('72f8ae52', component.options)
    }
    module.hot.accept("./subject-column.vue?vue&type=template&id=72f8ae52&scoped=true", function () {
      api.rerender('72f8ae52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/email-quarantine/columns/subject-column.vue"
export default component.exports